import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AbstractCommonService } from '../../abstracts/services/common/common.abstract';
import { IApiResponse } from '../../interfaces/api/api-response.interface';
import { ICountryProvince } from '../../interfaces/common/common/countryProvince.interface';
import { IStateProvince } from '../../interfaces/common/common/stateProvince.interface';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService extends AbstractCommonService {
  private apiUrl = environment.apiUrl;
  private sharedControllerSuffix = 'Onboarding/Onboarding/shared/';

  constructor(private http: HttpClient, private logger: LoggerService) {
    super();
  }

  async getStateProvince(): Promise<IStateProvince[]> {
    const url = `${this.apiUrl}${this.sharedControllerSuffix}state`;
    const result = await firstValueFrom(
      this.http
        .get<IApiResponse>(url)
        .pipe(
          catchError((error: ErrorEvent) =>
            throwError(() => new Error(error.message))
          )
        )
    );

    return result.data as IStateProvince[];
  }

  async getCountryProvince(): Promise<ICountryProvince[]> {
    const url = `${this.apiUrl}${this.sharedControllerSuffix}country`;
    const countryresult = await firstValueFrom(
      this.http
        .get<IApiResponse>(url)
        .pipe(
          catchError((error: ErrorEvent) =>
            throwError(() => new Error(error.message))
          )
        )
    );

    return countryresult.data as ICountryProvince[];
  }
}
